import { cn } from '@ab-inbev-eu/ui-library/components/utils';
import Spinner from '@ab-inbev-eu/ui-library/components/basic/Spinner';
import BlurredBg from '@ab-inbev-eu/ui-library/components/basic/BlurredBg';

export function FullPageSpinner(props: { className?: string }) {
  return (
    <BlurredBg
      className={{
        container: cn('inset-0 z-50 flex min-h-dvh w-full items-center justify-center', props.className),
        bg: 'inset-0',
      }}
    >
      <Spinner variant="light" />
    </BlurredBg>
  );
}
